var _excluded = ["hidden", "input", "meta", "disabled"];
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import Cushion from '../Cushion';
import Typography from '../Typography';
import style from './style';
var TextAreaContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", "\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: rgba(6, 67, 95, 0.3) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 2px 3px;\n  box-sizing: border-box;\n  color: ", ";\n  font-size: 14px;\n  lineHeight: 1.3;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n\n  ", "\n  ", "\n"])), function (props) {
  return props.disabled ? '#F3F3F3' : '#FFF';
}, function (props) {
  return props.error ? '#E26868;' : '#f9f9f9';
}, function (props) {
  return props.disabled ? '#E26868' : '#333';
}, function (props) {
  return props.hidden ? 'display: none;' : '';
}, function (props) {
  return props.disabled ? 'cursor: not-allowed;' : '';
});
var StyledTextArea = styled.textarea(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: transparent;\n  box-sizing: inherit;\n  border: none;\n  color: inherit;\n  cursor: inherit;\n  fontsize: inherit;\n  line-height: inherit;\n  outline: 0;\n  padding: 12px;\n  position: relative;\n  resize: none;\n  width: inherit;\n  z-index: 1;\n\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: #b2b2b2;\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #b2b2b2;\n  }\n  :-ms-input-placeholder {\n    /* IE 10+ */\n    color: #b2b2b2;\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    color: #b2b2b2;\n  }\n\n  &:focus + .prui-textarea__focus {\n    padding-bottom: 110% !important;\n    width: 110% !important;\n    left: -5% !important;\n  }\n"])));
var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var hidden = props.hidden,
    input = props.input,
    _props$meta = props.meta,
    _props$meta$touched = _props$meta.touched,
    touched = _props$meta$touched === void 0 ? false : _props$meta$touched,
    _props$meta$error = _props$meta.error,
    error = _props$meta$error === void 0 ? false : _props$meta$error,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextAreaContainer, {
    disabled: disabled,
    hidden: hidden,
    error: touched && error
  }, /*#__PURE__*/React.createElement(StyledTextArea, _extends({}, otherProps, input, {
    ref: ref,
    disabled: disabled,
    hidden: hidden,
    "data-hj-whitelist": true
  })), /*#__PURE__*/React.createElement("span", {
    className: "prui-textarea__focus",
    style: style.focus
  }, /*#__PURE__*/React.createElement("span", {
    className: "prui-textarea__focus-circle",
    style: style.circle
  }, /*#__PURE__*/React.createElement("span", {
    style: style.circleBefore
  })))), touched && error && /*#__PURE__*/React.createElement(Cushion, {
    top: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "label",
    preset: "description",
    color: "#E26868"
  }, error)));
});
TextArea.defaultProps = {
  input: {},
  meta: {},
  hidden: false,
  disabled: false
};
export default TextArea;